/**
 * Copy for the Capture post-create confirm — after Build succeeds, ask whether
 * to open the builder or stay on Capture. Same openModal / DeleteModal shape
 * as deleteConfirmCopy / detachConfirmCopy.
 *
 * Title + Yes / Stay buttons are enough; `note: false` hides DeleteModal's
 * default "cannot be undone" line so this prompt has no body paratext.
 */
export const postCreateWheelConfirmCopy = () => ({
  title: "Would you like to work on this wheel?",
  note: false,
  confirmLabel: "Yes",
  cancelLabel: "No, Stay on Capture",
});
